function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6667 5.33333C20.545 5.33333 18.5101 6.17619 17.0098 7.67648C15.5095 9.17677 14.6667 11.2116 14.6667 13.3333C14.6667 15.4551 15.5095 17.4899 17.0098 18.9902C18.5101 20.4905 20.545 21.3333 22.6667 21.3333H41.3334C43.4551 21.3333 45.4899 20.4905 46.9902 18.9902C48.4905 17.4899 49.3334 15.4551 49.3334 13.3333C49.3334 11.2116 48.4905 9.17677 46.9902 7.67648C45.4899 6.17619 43.4551 5.33333 41.3334 5.33333H22.6667Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3334 24C39.2116 24 37.1768 24.8429 35.6765 26.3431C34.1762 27.8434 33.3334 29.8783 33.3334 32C33.3334 34.1217 34.1762 36.1566 35.6765 37.6569C37.1768 39.1571 39.2116 40 41.3334 40C43.4551 40 45.4899 39.1571 46.9902 37.6569C48.4905 36.1566 49.3334 34.1217 49.3334 32C49.3334 29.8783 48.4905 27.8434 46.9902 26.3431C45.4899 24.8429 43.4551 24 41.3334 24V24Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6667 32C14.6667 29.8783 15.5095 27.8434 17.0098 26.3431C18.5101 24.8429 20.545 24 22.6667 24H30.6667V40H22.6667C20.545 40 18.5101 39.1571 17.0098 37.6569C15.5095 36.1566 14.6667 34.1217 14.6667 32Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6667 42.6667C21.0844 42.6667 19.5377 43.1359 18.2221 44.0149C16.9065 44.894 15.8812 46.1434 15.2757 47.6052C14.6702 49.067 14.5117 50.6755 14.8204 52.2274C15.1291 53.7792 15.891 55.2047 17.0098 56.3235C18.1287 57.4423 19.5541 58.2043 21.106 58.513C22.6578 58.8216 24.2663 58.6632 25.7282 58.0577C27.19 57.4522 28.4394 56.4268 29.3184 55.1112C30.1975 53.7956 30.6667 52.2489 30.6667 50.6667V42.6667H22.6667Z",
  fill: "black"
});

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.7fc7c924.svg";
export { ForwardRef as ReactComponent };